module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner-container"
  }, [_c('div', {
    class: ['half-circle-spinner', _vm.size]
  }, [_c('div', {
    staticClass: "circle circle-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "circle circle-2"
  })]), _vm._v(" "), (_vm.message) ? _c('span', {
    staticClass: "spinner-message"
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55294821","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Spinner.vue
// module id = 1545
// module chunks = 4